const lst247BGVideo = require('./lst247-intro-bg.mp4');

export const videos = {
  lst247BGVideo
};
